<template>
  <div class="app-wrapper yd-display-flex yd-flexDirection-c">
    <my-header></my-header>

    <!--<transition name="bounce" mode="out-in">-->
      <router-view></router-view>
    <!--</transition>-->

    <my-footer></my-footer>
    <!--<cust-service></cust-service>-->
  </div>
</template>

<script>
import { WOW } from 'wowjs'
import myHeader from '@/components/myHeader'
import myFooter from '@/components/myFooter'
import custService from '@/components/custService'
export default {
  name: 'Layout',
  components: {myHeader, myFooter, custService}
}
</script>

<style scoped>
  .app-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    background: #F5F5F5;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue